import styled, { css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';

const siteId = site.id;
const siteWithBanner = siteId.includes('BR');

const isCurrentStepTitle = css`
  font-weight: 600;
`;

const isEnabledStepTitle = css`
  color: ${getColor('stepperPrimary')};
`;

const backgroundCircleCurrent = css`
  background: ${select('white')};
  border: 1px solid ${getColor('stepperPrimary')};
  box-shadow: 0px 0px 0px 3px ${getColor('stepperSecondary')};
`;

const withoutLine = css`
  background: ${select('white')};
  left: 29px;
`;

const isHoverStep = css`
  background-color: ${select('white')};
  color: ${getColor('stepperPrimary')};
  border: 1px solid ${getColor('stepperPrimary')};
`;

const isEnabledStyles = css`
  cursor: pointer;
`;

const StepCircle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.375rem;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: ${select('white')};
  background-color: ${({ isEnabled }) => (isEnabled ? getColor('stepperPrimary') : getColor('stepperSecondary'))};
  transition: background-color 0.3s linear;
  ${({ isEnabled, isCurrentStep }) => isEnabled && !isCurrentStep && isEnabledStyles}
  &:hover {
    ${withQuery.md.up()} {
      ${({ isEnabled, isCurrentStep }) => isEnabled && !isCurrentStep && isHoverStep}
    }
  }
`;

const BackgroundCircle = styled.div`
  width: 32px;
  height: 32px;
  position: relative;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ currentStep }) => currentStep && backgroundCircleCurrent};
`;

const LineProgressShared = styled.div`
  background: ${getColor('stepperPrimary')};
  height: 100%;
  width: ${({ enabledLine }) => (enabledLine ? '100' : '0')}%;
  transition: width 0.7s;
`;

const LineProgressContainer = styled.div`
  width: 100%;
  right: 31px;
  top: 32%;
  height: 3px;
  position: absolute;
  background: ${getColor('stepperSecondary')};
  ${({ stepId }) => stepId === 1 && withoutLine}
`;

const MainStep = styled.div`
  background: transparent;
  outline: none;
  border: 0;
  z-index: 1;
  padding: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ customStyles }) =>
    customStyles &&
    css`
      padding-right: 1rem;
    `}
`;

const StepWrapper = styled.div`
  display: flex;
  max-width: 1440px;
  margin: auto;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  padding: 0 1rem;
  @media (min-width: 1180px) {
    max-width: 1280px;
  }
  @media (min-width: 1480px) {
    max-width: 1480px;
  }
`;

const StepperContainer = styled.div`
  width: 100%;
  height: 75px;
  background-color: ${select('white')};
  box-shadow: -1px 2px 20px 0 rgba(0, 0, 0, 0.08);
  ${withQuery.md.down()} {
    padding: 0 1rem;
  }
  @media (max-width: 1200px) {
    margin-top: ${siteWithBanner ? '90' : '58'}px;
  }
`;

const MainStepWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex: ${({ stepId }) => (stepId === 1 ? 0 : 1)};
  position: relative;
  justify-content: flex-end;
`;

const StepTitle = styled.div`
  color: ${getColor('stepperSecondary')};
  ${({ currentStep }) => currentStep && isCurrentStepTitle}
  ${({ isEnabled }) => isEnabled && isEnabledStepTitle}
`;

export {
  StepperContainer,
  MainStep,
  StepCircle,
  StepWrapper,
  StepTitle,
  BackgroundCircle,
  LineProgressShared,
  MainStepWrapper,
  LineProgressContainer
};
